import gql from 'graphql-tag'

export const userFragment = gql`
  fragment UserFragment on User {
    id
    name
    fullName
    area {
      name
    }
    lmsProfiles {
      name
      color
    }
  }
`
